// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"244":"cce96e28","564":"d512e241","752":"7be7d02b"}[chunkId] + ".css";
};